module.exports = __webpack_public_path__ + "47a55ef100c3a16af5d73d5e5228abb5.pdf";